export const sxPopperCustomDesign = {
    ".MuiPickersCalendarHeader-label": {
        fontSize: "initial",
    },
    ".MuiPickersCalendarHeader-switchViewIcon": {
        fontSize: "initial",
    },
    ".MuiSvgIcon-fontSizeInherit": {
        fontSize: "initial",
    },
    ".MuiDayCalendar-weekDayLabel": {
        fontSize: "var(--font-size-small)",
    },
    ".MuiPickersDay-dayWithMargin": {
        fontSize: "var(--font-size-tiny)",
        "&:hover": {
            backgroundColor: "var(--palette-primary-50)",
            color: "var(--palette-primary-700)",
        },
        "&.Mui-selected": {
            backgroundColor: "var(--palette-primary-600)",
            "&:hover": {
                backgroundColor: "var(--palette-primary-700)",
                color: "#fff",
            },
        },
        "&.MuiPickersDay-today:not(.Mui-selected)": {
            border: "none",
            backgroundColor: "var(--palette-gray-100)",
        },
    },
    ".MuiPickersYear-yearButton": {
        fontSize: "var(--font-size-medium)",
    },
    ".MuiPickersMonth-monthButton": {
        fontSize: "var(--font-size-medium)",
    },
    ".MuiMenuItem-root": {
        fontSize: "var(--font-size-medium)",
    },
    ".MuiButton-text": {
        fontSize: "var(--font-size-small)",
    },
};
//# sourceMappingURL=styles.js.map